import controller from './client-edit-controller';
import template from './client-edit.html';

const ClientEditComponent = {
    bindings: {
        client: '<',
        clientTree: '<',
        relatedModels: '<'
    },
    controller,
    template,
};

export default ClientEditComponent;



// WEBPACK FOOTER //
// ./app/components/client-edit/client-edit-component.js